import {useEffect, useState} from 'react';
import { useWindowDimensions } from 'react-native';

const isLandscape = () => {
	const [isLandscape, setIsLandscape] = useState();
	const dimensions = useWindowDimensions();

	useEffect(() => {
		setIsLandscape(dimensions.height < dimensions.width);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return isLandscape;
};

export default isLandscape;